module.exports = __webpack_public_path__ + "static/media/icon_permission_white.56c54efc.png";